import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isArray' })
export class IsArrayPipe implements PipeTransform {
	/**
	 * Check if it's an array
	 * @param data String, Empty or Array
	 */
	transform(data: any): boolean {
		return Array.isArray(data);
	}
}
